// src/pages/Dashboard.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumb = ({ pageName, currentPage }) => {
  // Brand Color Constants
  const brandOrange = "#C04C2A";
  const brandDark = "#4A1B13";

  return (
    <div className="mb-6 flex flex-col gap-3 text-sm sm:flex-row sm:items-center sm:justify-between bg-white dark:bg-gray-800 px-4 py-4 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 transition-all">

      {/* Page Title with Brand Gradient */}
      <h2 className="text-xl font-bold text-gray-800 dark:text-white">
        {pageName}
      </h2>

      <nav aria-label="Breadcrumb">
        <ol className="flex items-center gap-1 font-medium">
          <li>
            <Link
              className="transition-colors hover:opacity-80"
              style={{ color: brandOrange }}
              to={'/dashboard'}
            >
              Dashboard
            </Link>
          </li>

          <li className="flex items-center gap-2">
            <span className="text-gray-400">/</span>
            <span
              className="dark:text-gray-300"
              style={{ color: brandDark }}
            >
              {currentPage}
            </span>
          </li>
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;